import React, { useCallback, useRef } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { logOut, registerRoutes } from '../../../func';
import axios from 'axios';
import { IconButton } from '../../../layout/form';
import M from '@materializecss/materialize';

const BuyingGroupTab = ({ pharmacyId }) => {
  const selectRef = useRef(null);

  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const [buyingGroupId, setBuyingGroupId] = useState('');
  const [allBuyingGroupsList, setAllBuyingGroupsList] = useState([]);
  const [buyingGroupList, setBuyingGroupList] = useState([]);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          getAllBuyingGroupsList: {
            func: () => {
              axios
                .get('/api/v2/buyinggroup/read/all', {
                  params: authData,
                })
                .then(result => setAllBuyingGroupsList(result.data))
                .catch(logOut);
            },
            type: 'r'
          },
          getBuyingGroupList: {
            func: pharmacyId => {
              axios
                .get('/api/v2/buyinggroup/read/many/by/pharmacyId', {
                  params: {
                    ...authData,
                    pharmacyId,
                  },
                })
                .then(result => setBuyingGroupList(result.data))
                .catch(logOut);
            },
            type: 'r',
          },
          addBuyingGroup: {
            func: (pharmacyId, buyingGroupId) => {
              axios
                .put('/api/v2/buyinggroup/update/addtopharmacy', {
                  ...authData,
                  pharmacyId,
                  buyingGroupId,
                })
                .then(result => dispatch(result))
                .catch(logOut);
            },
            type: 'u',
          },
          removeBuyingGroup: {
            func: (pharmacyId, buyingGroupId) => {
              axios
                .delete('/api/v2/buyinggroup/delete/removefrompharmacy', {
                  params: {
                    ...authData,
                    pharmacyId,
                    buyingGroupId,
                  },
                })
                .then(result => dispatch(result.data))
                .catch(logOut);
            },
            type: 'd',
          },
        },
        path
      ),
    [path, authData, dispatch]
  );

  useEffect(() => {
    networkCalls.getAllBuyingGroupsList();
  }, []);

  useEffect(() => {
    if (!pharmacyId) return;
    networkCalls.getBuyingGroupList(pharmacyId);
  }, [pharmacyId]);

  useEffect(() => {
    const { current } = selectRef;
    if (!allBuyingGroupsList?.length || !current) return;
    M.FormSelect.init(current);
    return () => M.FormSelect.getInstance(current)?.destroy();
  }, [selectRef.current, allBuyingGroupsList]);

  const addBuyingGroup = useCallback(
    async event => {
      event?.preventDefault();
      if (!buyingGroupId)
        dispatch({
          type: 'GLOBAL_TOAST',
          payload: {
            msg: 'No Buying Group Selected',
            class: 'orange white-text',
          },
        });

      await networkCalls.addBuyingGroup(pharmacyId, buyingGroupId);
      networkCalls.getBuyingGroupList(pharmacyId);
    },
    [buyingGroupId, pharmacyId, networkCalls]
  );

  const removeBuyingGroup = useCallback(
    async buyingGroupId => {
      await networkCalls.removeBuyingGroup(pharmacyId, buyingGroupId);
      networkCalls.getBuyingGroupList(pharmacyId);
    },
    [pharmacyId, networkCalls]
  );

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <div className="input-field col s12 m6">
          <select
            ref={selectRef}
            id="buyingGroupId"
            onChange={({ target: { value } }) => setBuyingGroupId(value)}
            value={buyingGroupId}
          >
            <option value="">Select A Buying Group</option>
            {allBuyingGroupsList?.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </select>
        </div>
        <div className="input-field col s12 m3">
          <a
            href="/"
            className="btn-small blue white-text waves-effect waves-light col s12"
            onClick={addBuyingGroup}
          >
            Add Buying Group
          </a>
        </div>
      </div>
      {buyingGroupList?.map(({ id, name }) => (
        <div key={id} className="card">
          <div className="card-content">
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <h5>{name.toLocaleUpperCase()}</h5>
              <IconButton icon="delete" onClick={() => removeBuyingGroup(id)} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BuyingGroupTab;
